import Const from 'constants';
import {ComboSummary as ClassicMLBComboSummary} from './mlb/classic';
import {ComboSummary as ClassicLOLComboSummary} from './lol/classic';
import {ComboSummary as ClassicNHLComboSummary} from './nhl/classic';

const componentMap = {
    [Const.LEAGUE_LOL]: ClassicLOLComboSummary,
    [Const.LEAGUE_MLB]: ClassicMLBComboSummary,
    [Const.LEAGUE_NHL]: ClassicNHLComboSummary,
};

export const Factory = {
    getComponent(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();

        return componentMap[sport] ?? null;
    },
};
